import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
// import Link from 'next/link';
import { useSelector, useDispatch } from 'react-redux';
import { makeAnyStringLengthShort, makeProductShortDescription } from '../../../helpers/ConversionHelper';
import Config from '../../../helpers/Config';
import { MakeApiCallSynchronous , MakeApiCallAsync } from '../../../helpers/ApiHelpers';
import rootAction from '../../../stateManagment/actions/rootAction';
import { LOADER_DURATION } from '../../../helpers/Constants';
import { getLanguageCodeFromSession } from '../../../helpers/CommonHelper';
    

const CompaignSection = () => {
    const dispatch = useDispatch();
    const [CampaignList, setCampaignList] = useState([]);
    const [adminPanelBaseURL, setBaseUrl] = useState(Config['ADMIN_BASE_URL']);

    useEffect(() => {
        // declare the data fetching function
        const getCampaignList = async () => {

             
            const headersCampaign = {
                // customerid: userData?.UserID,
                // customeremail: userData.EmailAddress,
                Accept: 'application/json',
                'Content-Type': 'application/json',
                   
            }


            const paramCampaign = {
                requestParameters: {
                    recordValueJson: "[]",
                },
            };

            const response = await MakeApiCallAsync(Config.END_POINT_NAMES['GET_WEB_CAMPAIGN_LIST'], null, paramCampaign, headersCampaign, "POST", true);
            if (response != null && response.data != null) {
                await setCampaignList(JSON.parse(response.data.data));
                console.log(JSON.parse(response.data.data));
            }


        }

        //--start loader
        dispatch(rootAction.commonAction.setLoading(true));

        // call the function
        getCampaignList().catch(console.error);

        //--stop loader
        setTimeout(() => {
            dispatch(rootAction.commonAction.setLoading(false));
        }, LOADER_DURATION);

    }, [])


    return (
        <>
            <div className="categories-banner-area pt-60 pb-30 bg-fcfbfb container">
                <div 
                // className="container-fluid"
                >



                    {
                        CampaignList != undefined && CampaignList.length > 0
                            ?
                            <div className="row">
{/* 
                                {
                                    CampaignList?.map((item, idx) =>

                                        <div className="col-lg-3 col-sm-6">
                                            <div className="offer-categories-box left-categories hover-active">
                                                <img src={adminPanelBaseURL + item.CoverPictureUrl} alt="image" height={190}/>
                                                <div className="content">
                                                    <span>{ makeAnyStringLengthShort(item.DiscountTitle, 30)}</span>
                                                    <h3>{item.MainTitle}</h3>
                                                    <Link to={`/${getLanguageCodeFromSession()}/campaign/${item.CampaignId}/${item.MainTitle}`} className="btn btn-primary">View Detail</Link>
                                                </div>

                                                <Link to={`/${getLanguageCodeFromSession()}/campaign/${item.CampaignId}/${item.MainTitle}`}  className="link-btn">

                                                </Link>
                                            </div>
                                        </div>

                                    )} */}
                        {/* <div style={{height: "160px", width: "auto", color: "#ffffff" ,backgroundSize:"cover",
                        backgroundPosition:"center",backgroundRepeat:"no-repeat",
                        borderRadius:"15px", backgroundImage: 'url('+adminPanelBaseURL + item.AttachmentURL+')'}}>
                          </div> */}
                                        <div className="col-lg-6 col-sm-12">
                                            <div style={{height:"430px",width: "auto", color: "#ffffff" ,backgroundSize:"cover",
                        backgroundPosition:"center",backgroundRepeat:"no-repeat",
                        borderRadius:"15px", backgroundImage: 'url('+adminPanelBaseURL + CampaignList[3].CoverPictureUrl+')'}} className="offer-categories-box left-categories hover-active">
                                                {/* <img src={adminPanelBaseURL + CampaignList[3].CoverPictureUrl} alt="image"/> */}
                                                <div className="content">
                                                    {/* <span>{ makeAnyStringLengthShort(CampaignList[3].DiscountTitle, 30)}</span> */}
                                                    <h3>{CampaignList[3].MainTitle}</h3>
                                                    <Link to={`/${getLanguageCodeFromSession()}/campaign/${CampaignList[3].CampaignId}/${CampaignList[3].MainTitle}`} className="btn btn-light ">View Detail</Link>
                                                </div>

                                                <Link to={`/${getLanguageCodeFromSession()}/campaign/${CampaignList[3].CampaignId}/${CampaignList[3].MainTitle}`}  className="link-btn">

                                                </Link>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-sm-12">
                                        <div className="row">
                                        <div className="col-lg-12 col-sm-12">
                                            <div className="offer-categories-box left-categories hover-active">
                                                {/* <img src={adminPanelBaseURL + CampaignList[1].CoverPictureUrl} alt="image" height={200}/> */}
                                            <div style={{height:"200px",width: "auto", color: "#ffffff" ,backgroundSize:"cover",
                        backgroundPosition:"center",backgroundRepeat:"no-repeat",
                        borderRadius:"15px", backgroundImage: 'url('+adminPanelBaseURL + CampaignList[1].CoverPictureUrl+')'}} className="offer-categories-box left-categories hover-active">
                                                <div className="content">
                                                    {/* <span>{ makeAnyStringLengthShort(CampaignList[1].DiscountTitle, 30)}</span> */}
                                                    <h3>{CampaignList[1].MainTitle}</h3>
                                                    <Link to={`/${getLanguageCodeFromSession()}/campaign/${CampaignList[1].CampaignId}/${CampaignList[1].MainTitle}`} className="btn btn-light ">View Detail</Link>
                                                </div>

                                                <Link to={`/${getLanguageCodeFromSession()}/campaign/${CampaignList[1].CampaignId}/${CampaignList[1].MainTitle}`}  className="link-btn">

                                                </Link>
                                            </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-sm-12">
                                            <div className="offer-categories-box left-categories hover-active">
                                                {/* <img src={adminPanelBaseURL + CampaignList[2].CoverPictureUrl} alt="image" height={200}/> */}
                                            <div style={{height:"200px",width: "auto", color: "#ffffff" ,backgroundSize:"cover",
                        backgroundPosition:"center",backgroundRepeat:"no-repeat",
                        borderRadius:"15px", backgroundImage: 'url('+adminPanelBaseURL + CampaignList[2].CoverPictureUrl+')'}} className="offer-categories-box left-categories hover-active">
                                                <div className="content">
                                                    {/* <span>{ makeAnyStringLengthShort(CampaignList[2].DiscountTitle, 30)}</span> */}
                                                    <h3>{CampaignList[2].MainTitle}</h3>
                                                    <Link to={`/${getLanguageCodeFromSession()}/campaign/${CampaignList[2].CampaignId}/${CampaignList[2].MainTitle}`} className="btn btn-light ">View Detail</Link>
                                                </div>

                                                <Link to={`/${getLanguageCodeFromSession()}/campaign/${CampaignList[2].CampaignId}/${CampaignList[2].MainTitle}`}  className="link-btn">

                                                </Link>
                                            </div>
                                        </div>
                                            </div>
                                        <div className="col-lg-6 col-sm-12">
                                            <div className="offer-categories-box left-categories hover-active">
                                                {/* <img src={adminPanelBaseURL + CampaignList[0].CoverPictureUrl} alt="image" height={200}/> */}
                                            <div style={{height:"200px",width: "auto", color: "#ffffff" ,backgroundSize:"cover",
                        backgroundPosition:"center",backgroundRepeat:"no-repeat",
                        borderRadius:"15px", backgroundImage: 'url('+adminPanelBaseURL + CampaignList[0].CoverPictureUrl+')'}} className="offer-categories-box left-categories hover-active">
                                                <div className="content">
                                                    {/* <span>{ makeAnyStringLengthShort(CampaignList[0].DiscountTitle, 30)}</span> */}
                                                    <h3>{CampaignList[0].MainTitle}</h3>
                                                    <Link to={`/${getLanguageCodeFromSession()}/campaign/${CampaignList[0].CampaignId}/${CampaignList[0].MainTitle}`} className="btn btn-light ">View Detail</Link>
                                                </div>

                                                <Link to={`/${getLanguageCodeFromSession()}/campaign/${CampaignList[0].CampaignId}/${CampaignList[0].MainTitle}`}  className="link-btn">

                                                </Link>
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                        </div>

                            </div>
                            :
                            <>
                            </>
                    }



                  

                </div>
            </div>
        </>
    );

}


export default CompaignSection;
